module.exports = {
  appTitle: 'Lloyd hearing test',
  //default '/img/logo,jpg', place logo anywhere in public folder and add correct path here
  logoFileName: '/img/logo.jpg',
  //ratio of logo image, logo width divided by logo height
  logoRatio: 2.56
}
